import { ListSubheader, List } from '@mui/material';
import { useLocation, matchPath } from 'react-router-dom';
import SidebarMenuItem from './item';
import menuItems, { MenuItem } from './items';
import { styled } from '@mui/material/styles';
import TreeItem from '@mui/lab/TreeItem';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from 'src/store/RootReducer';
import RecentActorsIcon from '@mui/icons-material/RecentActors';
import ScreenSearchDesktopIcon from '@mui/icons-material/ScreenSearchDesktop';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import { AccessTime, EventAvailable, CalendarToday  } from '@mui/icons-material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import SettingsIcon from '@mui/icons-material/Settings';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import AssuredWorkload from '@mui/icons-material/AssuredWorkload';
import NextPlan from '@mui/icons-material/NextPlan';
import { getAllBillingRoles, getAllTracks, getEmployeeById } from 'src/services/employeeService';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import EventIcon from '@mui/icons-material/Event';
import MoreTimeIcon from '@mui/icons-material/MoreTime';
import LibraryAddOutlinedIcon from '@mui/icons-material/LibraryAddOutlined';
import LibraryAddCheckOutlinedIcon from '@mui/icons-material/LibraryAddCheckOutlined';
import InsertChartOutlinedRoundedIcon from '@mui/icons-material/InsertChartOutlinedRounded';
import { BillingRole, Track } from 'src/models/employee';
import { EmployeesActions } from 'src/store/EmployeeReducer';
import TableChartOutlinedIcon from '@mui/icons-material/TableChartOutlined';
import SummarizeOutlinedIcon from '@mui/icons-material/SummarizeOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import MultilineChartOutlinedIcon from '@mui/icons-material/Assessment';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';
import BadgeIcon from '@mui/icons-material/Badge';


const MenuWrapper = styled(List)(
  ({ theme }) => `
    margin-bottom: ${theme.spacing(1)};
    padding: 0;

    & > .MuiList-root {
      padding: 0 ${theme.spacing(0)} ${theme.spacing(0)};
    }

    .MuiListSubheader-root {
      text-transform: uppercase;
      font-weight: bold;
      font-size: ${theme.typography.pxToRem(12)};
      color: #031349;
      padding: ${theme.spacing(0.8, 2)};
      line-height: 1.4;
    }
`
);

const SubMenuWrapper = styled(List)(
  ({ theme }) => `
    &.MuiList-root {
      padding: 0;

      .MuiList-root .MuiList-root .MuiListItem-root .MuiButton-root {
        font-weight: normal !important;
      }

      .MuiListItem-root {
        padding: 2px ${theme.spacing(0)};

        div:nth-child(2):not(.MuiCollapse-root, .MuiListItem-root){
          background: #031349 !important;
          height: 2.65rem !important;
          border-radius: 0px 5px 5px 0px !important;
        }
        .MuiButton-root {
          display: flex;
          color: #031349;
          background-color: ${theme.sidebar.menuItemBg};
          width: 100%;
          justify-content: flex-start;
          font-size: ${theme.typography.pxToRem(12)};
          padding-top: ${theme.spacing(1.25)};
          padding-bottom: ${theme.spacing(1.25)};
          padding-left: ${theme.spacing(5)};
          font-weight: normal;
          position: relative; 
          border-radius: 0;

          .MuiBadge-root {
            position: absolute;
            right: ${theme.spacing(4)};
            

            .MuiBadge-standard {
              background: ${theme.colors.primary.main};
              font-size: ${theme.typography.pxToRem(9)};
              font-weight: bold;
              text-transform: uppercase;
              color: ${theme.palette.primary.contrastText};
            }
          }
    
          .MuiButton-startIcon,
          .MuiButton-endIcon {
            transition: ${theme.transitions.create(['color'])};

            .MuiSvgIcon-root {
              font-size: inherit;
              transition: none;
            }
          }

          .MuiButton-startIcon {
            font-size: ${theme.typography.pxToRem(18)};
            margin-right: ${theme.spacing(1.5)};
            color: #031349;
          }
          
          .MuiButton-endIcon {
            margin-left: auto;
            font-size: ${theme.typography.pxToRem(22)};
          }

          &.Mui-active{
            background-color: rgba(3, 19, 73, 0.2);
          }
          &:hover {
           
            color: #031349;

            .MuiButton-startIcon,
            .MuiButton-endIcon {
                color: #031349;
            }
          }
        }

        &.Mui-children {
          flex-direction: column;
          line-height: 1;

          .Mui-children {
            .MuiList-root .MuiButton-text{
              padding-left: 68px};
            }
          }
        }

        &.Mui-children {
          flex-direction: column;
          line-height: 1;
        }

        .MuiCollapse-root {
          width: 100%;

          .MuiList-root {
            padding: ${theme.spacing(1, 0)};
          }

          .MuiListItem-root {
            padding: 2px ${theme.spacing(0)};

            .MuiButton-root {
              padding: ${theme.spacing(0, 2, 0, 6.5)};
              color: #031349;
              background-color: ${theme.sidebar.menuItemBg};
              width: 100%;
              justify-content: flex-start;
              font-size: ${theme.typography.pxToRem(12)};
              padding-top: ${theme.spacing(1.25)};
              padding-bottom: ${theme.spacing(1.25)};
              font-weight: normal;
              position: relative; 
              border-radius: 0;
              
            }
            .Mui-active{
              background-color: rgba(3, 19, 73, 0.2);
            }
          }
          
        }
      }
    }
`
);

const TreeWrapper = styled(TreeItem)(
  ({ theme }) => `
  .MuiTreeItem-label {
    color: ${theme.sidebar.menuItemColorActive};
    background: ${theme.sidebar.menuItemBg};
    height: 30px;
    font-size: ${theme.typography.pxToRem(13)};
    font-weight: bold;
    margin-top: 10px
  }
`
);

// const renderSidebarMenuItems = ({
//   items,
//   path
// }: {
//   items: any;
//   path: string;
// }): JSX.Element => (
//   <SubMenuWrapper>
//     {items &&
//       items.length > 0 &&
//       items.reduce((ev, item) => reduceChildRoutes({ ev, item, path }), [])}
//   </SubMenuWrapper>
// );

const renderSidebarMenuItems = ({
  items,
  path
}: {
  items: any;
  path: string;
}): JSX.Element => {
  return (
    <SubMenuWrapper>
      {items &&
        items.length > 0 &&
        items.reduce((ev, item) => reduceChildRoutes({ ev, item, path }), [])}
    </SubMenuWrapper>
  );
};

const reduceChildRoutes = ({
  ev,
  path,
  item
}: {
  ev: JSX.Element[];
  path: string;
  item: MenuItem;
}): Array<JSX.Element> => {
  const key = item?.name;
  const exactMatch = item?.link
    ? !!matchPath(
        {
          path: item?.link,
          end: true
        },
        path
      )
    : false;

  if (item && item.items && item.items.length > 0) {
    const partialMatch = item.link
      ? !!matchPath(
          {
            path: item.link,
            end: false
          },
          path
        )
      : false;
    ev.push(
      <SidebarMenuItem
        key={key}
        active={partialMatch}
        open={partialMatch}
        name={item.name}
        icon={item.icon}
        link={item.link}
        badge={item.badge}
        tabname={item.tabname}
      >
        {renderSidebarMenuItems({
          items: item?.items,
          path
        })}
      </SidebarMenuItem>
    );
  } else {
    ev.push(
      <SidebarMenuItem
        key={key}
        active={exactMatch}
        name={item.name}
        link={item.link}
        badge={item.badge}
        icon={item.icon}
        tabname={item.tabname}
      />
    );
  }
  return ev;
};

const SidebarMenu = ({ menuItemHandler }) => {
  const location = useLocation();
  const dispatch = useDispatch();

  const appUser = useSelector((state: RootStateType) => state.appReducer?.user);
  const isProjectManager = useSelector(
    (state: RootStateType) => state?.appReducer?.user?.IsProjectManager
  );

  const [baseMenuItems] = useState([
    {
      name: 'Dashboard',
      link: '/dashboard',
      icon: DashboardIcon,
      tabName: 'Dashboard'
    },
    {
      name: 'Segments',
      link: '/segments',
      icon: AccountBalanceWalletIcon,
      tabName: 'Segments'
    },
    {
      name: 'Clients',
      link: '/clients',
      icon: PeopleAltIcon,
      tabName: 'Clients'
    },
    {
      name: 'Stakeholders',
      link: '/stakeholders',
      icon: SupervisorAccountIcon,
      tabName: 'Stakeholders'
    },
    {
      name: 'Projects',
      link: '/project-details',
      icon: BusinessCenterIcon,
      tabName: 'Project'
    },
    {
      name: 'Employees',
      link: '/employees',
      icon: RecentActorsIcon,
      tabName: 'Employees'
    },
    {
      name: 'Holiday Calendar',
      link: '/holiday-calender',
      icon: CalendarToday,
      tabName: 'Holiday Calendar'
    },
    {
      name: 'Resource Management',
      link: '/resource-pool',
      icon: ScreenSearchDesktopIcon,
      tabName: 'Resource Management'
    },
    // {
    //   name: 'Project Health Summary',
    //   link: '/project-health',
    //   icon: PendingActionsIcon,
    //   tabName: 'Project Health Summary'
    // },
    {
      name: 'Resource Management',
      link: '/resource-management',
      icon: ScreenSearchDesktopIcon,
      tabName: 'Resource Management'
    },
    {
      name: 'Timesheet',
      icon: CalendarMonthIcon,
      items: [
        {
          name: 'Time Entry',
          link: '/time-entry',
          icon: MoreTimeIcon,
          tabName: 'Time Entry'
        },
        {
          name: 'Activity Management',
          link: '/activity-management',
          icon: LibraryAddOutlinedIcon,
          tabName: 'Activity Management'
        },
        {
          name: 'Task Assignment',
          link: '/task-assignment',
          icon: LibraryAddCheckOutlinedIcon,
          tabName: 'Task Assignment'
        },
        {
          name: 'Employee Timesheet',
          link: '/superuserTimeSheet',
          icon: MultilineChartOutlinedIcon,
          tabName: 'Employee Timesheet'
        }
      ]
    },
    {
      name: 'Attendance',
      link: '/attendance',
      icon: AccessTime,
      tabName: 'Attendance'
    },
    {
      name: 'Leave Management',
      icon: EventAvailable,
      items: [
        {
          name: 'Leave',
          link: '/leave-management',
          icon: ContactMailIcon,
          tabName: 'Leave Management'
        },
        {
          name: 'Work Model',
          link: '/work-model',
          icon: SettingsIcon,
          tabName: 'Work Model'
        },
        {
          name: 'Work From Home',
          link: '/work-from-home',
          icon: BusinessCenterIcon,
          tabName: 'Work From Home'
        }
      ]
    },
    {
      name: 'Admin Configurations',
      icon: LibraryBooksIcon,
      items: [
        {
          name: 'Role Management',
          link: '/role-management',
          icon: ContactMailIcon,
          tabName: 'Role Management'
        },
        {
          name: 'Configurations',
          link: '/configurations',
          icon: SettingsIcon,
          tabName: 'Configurations'
        },
        {
          name: 'Year Plan',
          link: '/year-plan',
          icon: CalendarMonthIcon,
          tabName: 'Year Plan'
        },
        {
          name: 'Define Leaves',
          link: '/define-leaves',
          icon: AccessTime,
          tabName: 'Define Leaves'
        },
        {
          name: 'Designations',
          link: '/designations',
          icon: BadgeIcon,
          tabName: 'Designations'
        }
      ]
    },
    {
      name: 'Company Configuration',
      icon: AssuredWorkload,
      items: [
        {
          name: 'Carry Forwarded Leaves',
          link: '/carry-forwarded-leaves',
          icon: NextPlan,
          tabName: 'Carry Forwarded Leaves'
        }
      ]
    },
    {
      name: 'Reports',
      icon: InsertChartOutlinedRoundedIcon,
      items: [
        {
          name: 'Task Based Report',
          link: '/taskBased-report',
          icon: AssignmentOutlinedIcon,
          tabName: 'Task Based Report'
        },
        {
          name: 'Detailed Report',
          link: '/detailed-report',
          icon: TableChartOutlinedIcon,
          tabName: 'Detailed Report'
        },
        {
          name: 'Summarized Report',
          link: '/summarized-report',
          icon: SummarizeOutlinedIcon,
          tabName: 'Summarized Report'
        },
        {   
          name: 'Variance Report',
          link: '/Variance-report',
          icon: PendingActionsIcon,
          tabName: 'Variance Report'
        }
      ]
    },
    {
      name: 'Feedback',
      link:'/feedback',
      icon: DashboardIcon,
      tabName: 'Feedback'
    },
    {
      name: 'Events',
      link:'/event-management',
      icon: EventIcon,
      tabName: 'Events'
    },
    {
      name: 'Employee Onboarding',
      link:'/employee-onboarding',
      icon: HandshakeOutlinedIcon,
      tabName: 'Employee Onboarding'
    },
  ]);

  var initialList: any = [];
  const [newMenuItems, setNewMenuItems] = useState(initialList);

  useEffect(() => {
    getAllTracks().then((res) => {
      dispatch(EmployeesActions.setTracks(res.data as Track[]));
    });

    getAllBillingRoles().then((res) => {
      dispatch(EmployeesActions.setBillingRoles(res.data as BillingRole[]));
    });
  }, [dispatch]);

  useEffect(() => {
    const menuItemsCopy: any = [...baseMenuItems];
    const correctOrder = [
      'Dashboard',
      'Segments',
      'Clients',
      'Stakeholders',
      'Projects',
      'Project Health Summary',
      'Employees',
      'Resource Management',
      'Timesheet',
      'Attendance',
      //'Holiday Calendar',
      //'Resource Management',
      'Leave Management',
      'Admin Configurations',
      'Company Configuration',
      'Feedback',
      'Events',
      'Employee Onboarding'
    ];

    const correctOrderOfLeave = [
      'Leave',
      'Work Model',
      'Work From Home',
    ];

    const correctOrderOfTimesheet = [
      'Time Entry',
      'Activity Management',
      'Task Assignment',
      'Reports',
      'Employee Timesheet'
    ];

    const correctOrderOfReports = [
      'Task Based Report',
      'Detailed Report',
      'Summarized Report',
      'Variance Report',      
    ];

    //need to resouce pool tab add from backend 
    //const app_users = {Claims: "Segments,Stakeholder,Resource Management,Resource Pool,Configurations,Project,Customer,Dashboard,Employee,Skills,Project Health Summary,Carry Forwarded Leaves,Holiday calendar,Leave Management,Define Leaves,Year Plan"}

    const allClaims = appUser?.Claims?.split(',').map((val) => {
      if (val === 'Customer') {
        //new name is Clients, not change permission name.. 
        return 'Clients';
      } else if (val === 'Stakeholder') {
        return 'Stakeholders';
      } else if (val === 'Employee') {
        return 'Employees';
      }else if(val === 'Skills') {
        return 'Holiday Calendar'
      }else if(val === 'Resource Pool'){
        return 'Resource Management';
      }else if (val === 'Feedback') {
        return 'Feedback';
      }else if (val === 'Event Management') {
        return 'Events';
      }
      else if (val === 'Employee Onboarding') {
        return 'Employee Onboarding';
      }
       else {
        return val;
      }
    });

    var newArr: any = [];
    let reportTabArray = menuItemsCopy.filter(
      (ele) => ele.name === 'Reports'
    );
    let reportTab = reportTabArray[0]?.items ? 
    reportTabArray[0] : reportTabArray[1];


    let timesheetTabArray = menuItemsCopy.filter(
      (ele) => ele.name === 'Timesheet'
    );
    let timesheetTab = timesheetTabArray[0]?.items ? 
      timesheetTabArray[0] : timesheetTabArray[1];
      
    let leaveManagementTabArray = menuItemsCopy.filter(
      (ele) => ele.name === 'Leave Management'
    );
    let leaveManagementTab = leaveManagementTabArray[0]?.items ? 
      leaveManagementTabArray[0] : leaveManagementTabArray[1];

    let adminConfigTab = menuItemsCopy.filter(
      (ele) => ele.name === 'Admin Configurations'
    )[0];

    let companyConfigurationTab =  menuItemsCopy.filter(
      (ele) => ele.name === 'Company Configuration'
    )[0];
    
    const companyConfigItems = companyConfigurationTab?.items;
    const configItems = adminConfigTab?.items;
    const roleManagementItem = configItems.filter(
      (ele) => 'Role Management' === ele?.tabName
    );
    /* const yearPlanItem = configItems.filter(
      (ele) => 'Year Plan' === ele?.tabName
    ); */

    let dropdownReport = [];
    let dropdownTimesheet = [];
    let dropdownLeaveManagement = [];
    let dropdownCompanyConfiguration = [];
    let dropdownItems: any = [];

    if (appUser?.Roles.split(',').includes('Super User')) {
      dropdownItems.push(roleManagementItem[0]);
    }

    /* dropdownItems.push(yearPlanItem[0]); */


    allClaims?.forEach((item) => {
      const x = menuItemsCopy.filter((ele) => item === ele?.tabName);
      const y = configItems?.filter((ele) => item === ele?.tabName);
      const z = companyConfigItems?.filter((ele) => item === ele?.tabName);

      const s = leaveManagementTab?.items?.filter((ele) => item === ele?.tabName);
      const v = timesheetTab?.items?.filter((ele) => item === ele?.tabName);
      const r = reportTab?.items?.filter((ele) => item === ele?.tabName);

      if (x.length > 0 && x !== undefined) {
        newArr.push(x[0]);
      }
      if (y.length > 0 && y !== undefined) {
        dropdownItems.push(y[0]);
      }
      if(z.length > 0 && z !== undefined) {
        dropdownCompanyConfiguration.push(z[0]);
      }
      if(s.length > 0 && z !== undefined) {
        dropdownLeaveManagement.push(s[0]);
      }
      if(v.length > 0 && v !== undefined) {
        dropdownTimesheet.push(v[0]);
      }
      if(r.length > 0 && r !== undefined) {
        dropdownReport.push(r[0]);
      }
    });
    
    let newDropdownLeaveManagement = [];
    correctOrderOfLeave.forEach((k) => {
      let n = dropdownLeaveManagement.filter((obj) => {
        return obj.name === k;
      });
      if (n.length > 0) {
        newDropdownLeaveManagement.push(n[0]);
      }
    });

    let newDropdownTimesheet = [];
    correctOrderOfTimesheet.forEach((k) => {
      let n = dropdownTimesheet.filter((obj) => {
        return obj.name === k;
      });
      if (n.length > 0) {
        newDropdownTimesheet.push(n[0]);
      }
    });

    adminConfigTab.items = dropdownItems;
    if (adminConfigTab?.items.length > 0) {
      newArr.push(adminConfigTab);
    }

    companyConfigurationTab.items = dropdownCompanyConfiguration;
    if(companyConfigurationTab?.items.length > 0) {
      newArr.push(companyConfigurationTab);
    }

    leaveManagementTab.items = newDropdownLeaveManagement;
    if(leaveManagementTab?.items?.length > 0) {
      newArr.push(leaveManagementTab);
    }

    reportTab.items = dropdownReport;

    timesheetTab.items = newDropdownTimesheet;
    if (timesheetTab?.items?.length > 0) {
      let newItems = [];
      if (
        stringToBoolean(isProjectManager) === true ||
        appUser?.Roles.split(',').includes('Super User')
      ) {
        for (let i = 0; i < timesheetTab?.items?.length; i++) {
          newItems.push(timesheetTab?.items[i]);
        }
        timesheetTab.items = newItems;
        newArr.push(timesheetTab);
      } else {
        for (let i = 0; i < timesheetTab?.items?.length; i++) {
          if (
            timesheetTab?.items[i]?.name !== 'Activity Management' &&
            timesheetTab?.items[i]?.name !== 'Task Assignment'
          ) {
            newItems.push(timesheetTab?.items[i]);
          }
        }
      }

      //Reports
      if (reportTab?.items?.length > 0) {
        let reportItems = [];
        for (let i = 0; i < reportTab?.items?.length; i++) {
          reportItems.push(reportTab?.items[i]);
        }

        let sortedReports: any = [];

        correctOrderOfReports.forEach((k) => {
          let n = reportItems.filter((obj) => {
            return obj.name === k;
          });
          if (n.length > 0) {
            sortedReports.push(n[0]);
          }
        });

        const reportItem = {
          name: 'Reports',
          icon: InsertChartOutlinedRoundedIcon,
          items: sortedReports
        };

        newItems.push(reportItem);
      }

      timesheetTab.items = newItems;
      newArr.push(timesheetTab);
    }

    let sorted: any = [];

    correctOrder.forEach((k) => {
      let n = newArr.filter((obj) => {
        return obj.name === k;
      });
      if (n.length > 0) {
        sorted.push(n[0]);
      }
    });
    setNewMenuItems(sorted);
  }, [appUser, baseMenuItems]);

  //selected after close side panel with mobile view
  const selectedSideBarItem = () => {
    menuItemHandler(true);
  }

  const stringToBoolean = (str) => {
    if (typeof str !== 'string') {
        return false;
    }
 
    return str.toLowerCase().trim() === 'true';
  }

  return (
    <>
      <MenuWrapper onClick={selectedSideBarItem}
        subheader={
          <ListSubheader component="div" disableSticky>
            {/*Sub Header is Disabled*/}
          </ListSubheader>
        }
      >
        {renderSidebarMenuItems({
          items: newMenuItems,
          path: location?.pathname
        })}
      </MenuWrapper>
    </>
  );
};

export default SidebarMenu;
